import { render } from "./FormLogin.vue?vue&type=template&id=3730da7d&scoped=true"
import script from "./FormLogin.vue?vue&type=script&lang=js"
export * from "./FormLogin.vue?vue&type=script&lang=js"

import "./FormLogin.vue?vue&type=style&index=0&id=3730da7d&scoped=true&lang=css"

import exportComponent from "/Users/vitechasia/Documents/Kantor/project_nuxt/vuess/vtadesk-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3730da7d"]])

export default __exports__